<template>
  <div>
    <l-table :tableConfig="tableConfig" :searchParams="time" ref="childRef">
      <template slot="searchConditions">
        <a-range-picker
          :value="time"
          :showToday="false"
          :show-time="{ format: 'HH:mm' }"
          format="YYYY-MM-DD HH:mm"
          :placeholder="$t('admin.monitor.timePicker.placeholder')"
          @change="onChange"
          @ok="onOk"
        />
      </template>
      <template #body="{ record }">
        <span>{{ record.body == '' ? '--' : record.body }}</span>
      </template>
      <template slot="searchActions"> </template>
    </l-table>
  </div>
</template>

<script>
import LTable from '@/components/LTable/index.vue'

export default {
  components: {
    LTable
  },
  data() {
    return {
      keyword: undefined,
      tableConfig: {
        tableName: this.$t('admin.monitor.title'),
        tableColumns: [
          {
            title: this.$t('admin.monitor.columns.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center'
          },
          {
            title: this.$t('admin.monitor.columns.operationTime'),
            dataIndex: 'operationTime',
            key: 'operationTime',
            align: 'center'
          },
          {
            title: this.$t('admin.monitor.columns.operationUser'),
            dataIndex: 'operationUser',
            key: 'operationUser',
            align: 'center'
          },
          {
            title: this.$t('admin.monitor.columns.content'),
            dataIndex: 'body',
            key: 'body',
            align: 'center',
            width: 300,
            scopedSlots: { customRender: 'body' }
          },
          {
            title: this.$t('admin.monitor.columns.url'),
            dataIndex: 'url',
            key: 'url',
            align: 'center',
            width: 300
          },
          {
            title: this.$t('admin.monitor.columns.ip'),
            dataIndex: 'ip',
            key: 'ip',
            align: 'center'
          }
        ],
        tablePort: {
          list: '/admin/monitor/list'
        }
      },
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 14 }
      },
      childRef: '',
      time: []
    }
  },
  methods: {
    search() {},
    onChange(value, dateString) {
      this.time = dateString
      if (dateString[0] == '') {
        this.$refs.childRef.getList({ condition: {} })
      } else {
        let param = {
          startTime: this.time[0] + ':00',
          endTime: this.time[1] + ':00'
        }
        this.$refs.childRef.getList({ condition: param })
        setTimeout(() => {
          this.$refs.childRef.defaultQuery = true
        }, 1000)
      }
    },
    onOk() {
      let param = {
        startTime: this.time[0] + ':00',
        endTime: this.time[1] + ':00'
      }
      this.$refs.childRef.getList({ condition: param })
    }
  }
}
</script>

<style lang="less">
.l-form {
  .ant-form-item {
    margin-bottom: 0 !important;
    width: 250px;
    line-height: 30px;
  }
  .ant-form-item-label {
    margin-top: 10px;
  }
}
/deep/ .ant-calendar-footer-btn {
  display: none !important;
}
.ant-calendar-ok-btn .ant-calendar-ok-btn-disabled {
  display: none !important;
}
</style>
